export const common = {
	//Menu
	"menu.play": "Jugar",
	"menu.ranking": "Clasificación",
	"menu.prizes": "Premios",
	"menu.rules": "Reglas",
	"menu.leagues": "Ligas",
	"menu.betwayAccount": "Cuenta Betway",
	"menu.terms": "T&Cs",

	//Play
	"play.heroTitle": "¡Predice los resultados y gana premios!",
	"play.heroSubtitle": "¿Qué equipo ganará? ¿Cuántos goles anotarán? ¡Predice ahora y compite contra tus amigos!",
	"play.playNow": "Jugar Ahora",
	"play.seePrizes": "Ver Premios",
	"play.statistics": "Estadísticas",
	"play.lastMatches": "Últimos 5 partidos de cada equipo",
	"play.stats": "Estadísticas",

	//Ranking
	"ranking.season": "Temporada",
	"ranking.weekly": "Semanal",
	"ranking.selectType": "Seleccionar tipo de clasificación",
	"ranking.selectWeek": "Seleccionar semana",
	"ranking.myPosition": "Mi posición",
	"ranking.points": "Puntos",
	"ranking.rank": "Rango",
	"ranking.topMembers": "Top 20 miembros",
	"ranking.noRanking": "Aún no hay tabla de clasificación.",
	"ranking.competitionStart": "Una vez que comience la competencia, todos los usuarios que jugaron Score Predict se clasificarán aquí.",
	"ranking.loadMore": "Cargar Más",
	"ranking.loading": "Cargando...",

	//Leagues
	"leagues.heroTitle": "¡Compite contra tus amigos o únete a ligas públicas!",
	"leagues.heroSubtitle": "¿Quién tiene las mejores habilidades de predicción? ¡Crea o únete a una liga para descubrirlo!",
	"leagues.createLeague": "Crear una liga",
	"leagues.joinLeague": "Unirse a una liga",
	"leagues.createLeagueButton": "Crear liga",
	"leagues.joinLeagueButton": "Unirse a liga",
	"leagues.enterName": "Ingresa el nombre de la liga",
	"leagues.enterCode": "Ingresa el código de invitación",
	"leagues.myLeagues": "Mis ligas",
	"leagues.member": "miembro",
	"leagues.members": "miembros",
	"leagues.membersCapital": "Miembros",
	"leagues.league": "Liga",
	"leagues.shareCodeText": "Tus amigos pueden unirse a tu liga usando este código:",
	"leagues.shareCode": "Compartir código",
	"leagues.editLeague": "Editar liga",
	"leagues.delete": "Eliminar",
	"leagues.leave": "Salir",
	"leagues.deleteWarning": "Todo el historial y los miembros serán eliminados permanentemente.",
	"leagues.leaveWarning": "Tus puntos de predicción y clasificación serán eliminados.",
	"leagues.confirmDelete": "Sí, eliminar",
	"leagues.confirmLeave": "Sí, salir",
	"leagues.cancel": "Cancelar",
	"leagues.ban": "Prohibir",
	"leagues.edit": "Editar",
	"leagues.save": "Guardar",

	//Errors
	"errors.savingPredictions": "Error al guardar predicciones",

	//Predictions
	"predictions.successModal.title": "¡Predicciones Confirmadas!",
	"predictions.successModal.subtitle": "¡Tus predicciones han sido guardadas exitosamente!",
	"predictions.successModal.close": "Cerrar",
	"predictions.seasonEnd.title": "¡Temporada Completa!",
	"predictions.seasonEnd.message":
		"¡Eso es todo para esta temporada de BW ScorePredict — gran trabajo! Felicitaciones a nuestro ganador del gran premio, [username], quien ganó un viaje para dos para ver al Arsenal en vivo en el Emirates Stadium. Mientras la acción toma un breve descanso, ya nos estamos preparando para la próxima ronda. Mantente atento a las actualizaciones y prepárate para volver con predicciones aún más precisas.",
	"predictions.seasonEnd.subtitle": "¡No podemos esperar a tenerte de vuelta en el juego!",
	"predictions.seasonEnd.myPosition": "Mi Posición",
	"predictions.seasonEnd.points": "Puntos",
	"predictions.seasonEnd.rank": "Rango",
	"predictions.seasonEnd.topMembers": "Top 10 miembros",
	"predictions.countdown.deadline": "Fecha límite",
	"predictions.countdown.deadlineMissed": "Fecha límite perdida",
	"predictions.countdown.matchweekDeadline": "Fecha límite de la jornada",
	"predictions.countdown.deadlineMissedMessage":
		"No hiciste tus predicciones para esta semana, así que no se ganaron puntos, ¡pero siempre hay la próxima semana para recuperarse!",
	"predictions.countdown.days": "DÍAS",
	"predictions.countdown.hours": "HORAS",
	"predictions.countdown.minutes": "MIN.",
	"predictions.countdown.seconds": "SEG.",
	"predictions.bonusFooter.loadingOdds": "Cargando cuotas...",
	"predictions.bonusFooter.draw": "Empate",
	"predictions.bonusFooter.unknown": "Desconocido",
	"predictions.bonusFooter.oddsToWin": "Cuotas para Ganar",
	"predictions.roundSelector.previousRound": "Ronda anterior",
	"predictions.roundSelector.nextRound": "Siguiente ronda",
	"predictions.points.totalPoints": "Puntos Totales",
	"predictions.points.currentPosition": "Posición actual",
	"predictions.points.points": "Puntos",
	"predictions.points.totalPointsLabel": "Puntos totales",
	"predictions.submitButton.submitting": "Enviando...",
	"predictions.submitButton.predictionsSaved": "Predicciones Guardadas",
	"predictions.submitButton.updatePredictions": "Actualizar Predicciones",
	"predictions.submitButton.submitAllPredictions": "Enviar Todas las Predicciones",
	"predictions.predictionCard.result": "Resultado",
	"predictions.predictionCard.pts": "Pts",

	//Predictions Info Card
	"predictions.infoCard.title": "¡Predice los resultados y gana premios!",
	"predictions.infoCard.description":
		"¿Quién saldrá victorioso? ¿Cuántos goles anotarán? ¡Predice ahora y compite contra tus amigos! Se aplican reglas y términos y condiciones.",
	"predictions.infoCard.playButton": "Jugar Ahora",
	"predictions.infoCard.prizesButton": "Ver Premios",

	//Common Components
	"common.shareCard.title": "Invita a tus Amigos a Jugar",
	"common.shareCard.description":
		"¡Invita a tus amigos a jugar BW ScorePredict para ver quién de ustedes es el mejor manager de fútbol, y para que todos tengan la oportunidad de ganar premios semanales!",
	"common.shareCard.button": "Invitar Amigos",
	"common.shareCard.shareTitle": "Descargar BetwayScores",
	"common.shareCard.shareBody": "¡Descarga BetwayScores y compite contra tus amigos en BW ScorePredict!",

	"common.accessDenied.title": "Descargar la App Betway Scores",
	"common.accessDenied.description":
		"Para acceder a este contenido, por favor descarga la app Betway Scores. Obtén los últimos resultados, predicciones y características exclusivas al alcance de tus dedos.",
	"common.accessDenied.rulesText": "Disponible para dispositivos iOS y Android. ¡Descarga ahora para comenzar!",
	"common.accessDenied.button": "Descargar App Betway Scores",

	"common.prizesInfoCard.title": "Información sobre Premios",
	"common.prizesInfoCard.description1":
		"No necesitas tener una cuenta Betway para jugar BW ScorePredict, sin embargo para canjear un premio semanal quedando en el Top 10 en cualquier semana, necesitas tener una cuenta Betway para que esas ganancias sean depositadas.",
	"common.prizesInfoCard.description2": "Ve las Reglas y Términos y Condiciones del juego para detalles de los premios semanales y generales.",
	"common.prizesInfoCard.button": "Ver Reglas",

	//Prizes Fragment
	"prizes.prizeCard1.title": "Gran Premio – Ver Arsenal en el Emirates Stadium",
	"prizes.prizeCard1.description":
		"Gana un viaje para dos para ver jugar al Arsenal en el Emirates Stadium en Londres, incluyendo vuelos (si es necesario), alojamiento (si es necesario) y £500 de dinero para gastos.",
	"prizes.prizeCard2.title": "Ganador de Ronda – Premio en efectivo en tu cuenta Betway",
	"prizes.prizeCard2.description":
		"El mejor jugador cada semana ganará €150 (o equivalente en moneda – ver sección 'Reglas') como efectivo depositado en su cuenta Betway.",
	"prizes.prizeCard3.title": "Puestos 2-10 cada ronda – Premio en efectivo en tu cuenta Betway",
	"prizes.prizeCard3.description":
		"Aquellos que terminen del 2º al 10º puesto cada semana también recibirán premios en efectivo en su cuenta Betway. Ver la sección 'Reglas' para las cantidades exactas que puedes ganar.",

	"common.modal.pointsFormat": "+{points}pts",

	//Betway Account Fragment
	"betwayAccount.title": "Abrir una Cuenta Betway",
	"betwayAccount.description":
		"No necesitas tener una cuenta Betway para jugar BW ScorePredict, sin embargo para canjear un premio semanal quedando en el Top 10 en cualquier semana, necesitas tener una cuenta Betway para que esas ganancias sean depositadas.",
	"betwayAccount.rulesText": "Ve las Reglas y Términos y Condiciones del juego para detalles de los premios semanales y generales.",
	"betwayAccount.button": "Abrir una Cuenta Betway",
};
